// Presentation metadata only. Calculations remain in the shared API.
const config = Object.freeze({
  endpoint: '/api/calculators/tax-free-cash/calculate',
  fields: ['fundValueAtADay', 'taxFreeCashAtADay', 'fundValueToday', 'transferValueToday'],
  example: [100000, 30000, 150000, 150000],
  subject: 'comparison', initialMessage: 'Enter your plan values to see the comparison.',
  validationMessage: 'Enter a numeric amount in pounds.',
  successMessage: 'Comparison calculated using the historical workbook method.'
});
export default config;
